import { baseApi } from "api/BaseApi";

import { QaTicket, QaTicketPayload } from "./qa.types";

export const qaApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createQaTicket: build.mutation<QaTicket, QaTicketPayload>({
      query: (body) => ({
        url: `v2/qa/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["QA_TICKETS"],
    }),
  }),
  overrideExisting: false,
});

export const { useCreateQaTicketMutation } = qaApi;
